module.exports = __webpack_public_path__ + "img/icon_action_dropdown.svg";